import { render, staticRenderFns } from "./PackagesTypeList.vue?vue&type=template&id=0a7823d4&"
import script from "./PackagesTypeList.vue?vue&type=script&lang=js&"
export * from "./PackagesTypeList.vue?vue&type=script&lang=js&"
import style0 from "./PackagesTypeList.vue?vue&type=style&index=0&id=0a7823d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCheckbox,VIcon,VRadio,VRadioGroup})
